import { IntlWrapper } from './components';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@kui-react/theme';

import './index.css';
import Home from './pages/Home';
import OAuthCallback from './pages/OAuthCallback';

// Eager (not lazy) imports: Home ↔ OAuthCallback is the silent-login hot path.
// Suspense chunk hops between those routes were an extra spinner flash on every
// Starfleet round-trip; both pages are small enough to ship in the main bundle.

const root = createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <IntlWrapper>
      <ThemeProvider theme='dark' withCanvas withReset>
        <BrowserRouter basename='/'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/oauth/callback' element={<OAuthCallback />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </IntlWrapper>
  </StrictMode>
);
